<template>
  <div class="modify-page">
    <navigation
      class="header"
      :theme="{
        background: '#fff',
      }"
    >信息修改
    </navigation>
    <div class="form-container">
      <div class="step-title">
        <img src="./images/img_step01@2x.png">
        <h2>修改信息确认</h2>
        <p>为确认您为本人操作，需验证现手机号</p>
        <span>验证码已发送至您的手机 {{ form.mobile | mobile }}</span>
      </div>
      <van-form
        ref="form"
        onsubmit="return false;"
      >
        <div class="form-item underline-un-focus code">
          <van-field
            v-model="form.smsCode"
            name="smsCode"
            maxlength="6"
            type="number"
            placeholder="请输入验证码"
            :rules="[{ required: true, message: '请输入验证码' },{ pattern: /[0-9]{6}$/, message: '请输入正确的验证码' }]"
          />
          <nd-send-code
            fmt="已发送(ms)"
            ref="smsCode"
            class="send-code"
            :sendCode="sendCodeHandler"
            v-if="showSendCode"
          />
        </div>

      </van-form>
      <nd-button
        class="btn"
        :disabled="isDisabled"
        :loading="pending"
        @click="next"
      >下一步</nd-button>

      <!-- <p class="tips">现手机号不可用？</p> -->
    </div>

  </div>
</template>


<script>
import { mapActions } from 'vuex'
import { getKey } from '../../../assets/utils'
export default {
  data () {
    return {
      form: {
        mobile: '',
        smsCode: '',
        smsKey: ''
      },
      pending: false,
      rules: {
        smsCode: [
          {
            require: true,
            message: '请输入验证码',
            trigger: 'blur'
          },
          {
            regular: /[0-9]{6}$/,
            message: '验证码错误，请重新输入',
            trigger: 'blur'
          }
        ]
      },
      errorTip: ''
    }
  },
  mounted () {
    this.form.mobile = getKey('userInfo')?.mobile
    // this.$refs.smsCode.clickHandler()
    this.$bus.$emit('ready')
  },

  computed: {
    isDisabled () {
      return this.form.smsCode?.length !== 6
    },
    showSendCode () {
      return true
    }
  },
  methods: {
    ...mapActions('modify', ['userChangeConfirm']),
    ...mapActions('user', ['getCommonSmsCode']),
    async sendCodeHandler () {
      const response = await this.getCommonSmsCode({
        smsType: 'USER_INFO_CHANGE'
      })
      if (response.success) {
        this.form.smsKey = response.data.smsKey
        return true
      }
      return false
    },
    async next () {
      await this.$refs.form.validate()
      if (!this.form.smsKey) {
        this.$message('请获取验证码')
        return
      }
      this.pending = true
      const { success, data, msg } = await this.userChangeConfirm({
        smsKey: this.form.smsKey,
        smsCode: this.form.smsCode
      })
      this.pending = false
      if (success && data.result === 'Y') {
        this.$router.push('/modify/base')
      } else {
        this.$message(msg || '请获取验证码')
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

.modify-page {
  min-height: 100vh;
  .tips {
    margin-top: 60px ;
  }
  .form-container {
    border-top: 20px solid #f8f8f8;
    padding:30px 40px;

    .step-title {
      display: flex;
      flex-direction: column;
      & > img {
        width: 670px;
        height: 76px;
      }
      h2 {
        font-size: 42px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        margin-top: 40px;
      }
      p {
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        margin-top: 15px;
      }
      span {
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
      }
    }
    .btn{
      margin-top: 80px;
    }
    .form-item {
      display: flex;
      margin-top: 50px;
      border-bottom: 1px solid #eee;
      
     
      .send-code {
        padding:0 20px;
        border-radius: 28px;
        margin-bottom: 8px;
        span {
            display: inline-block;
            font-size: 22px;
        }
        }
    }
  }
}
</style>